export const storeLiveData = [
    {
        "id": 1,
        "image": require("../images/store/store_11.jpeg"),
        "area": "仁德區",
        "name": "捷絲旅台南館",
        "link": "https://ciaoz.pixnet.net/blog/post/90989776"
    },
    {
        "id": 2,
        "image": require("../images/store/store_12.jpeg"),
        "area": "安平區",
        "name": "我小時候設計旅店",
        "link": "https://rt0816.pixnet.net/blog/post/221800576"
    },
    {
        "id": 3,
        "image": require("../images/store/store_13.jpeg"),
        "area": "北區",
        "name": "天下南隅",
        "link": "https://sai083.pixnet.net/blog/post/355771066"
    },
    {
        "id": 4,
        "image": require("../images/store/store_14.jpeg"),
        "area": "中西區",
        "name": "道達旅店",
        "link": "https://miyakohsiao.pixnet.net/blog/post/121772498"
    },
    {
        "id": 5,
        "image": require("../images/store/store_15.jpeg"),
        "area": "北區",
        "name": "塔木德南方家屋",
        "link": "https://rabbit30895.pixnet.net/blog/post/232811092"
    },
    {
        "id": 6,
        "image": require("../images/store/store_16.jpeg"),
        "area": "中西區",
        "name": "窄巷子公寓",
        "link": "https://jssophia.pixnet.net/blog/post/70418265"
    },
    {
        "id": 7,
        "image": require("../images/store/store_17.jpeg"),
        "area": "安平區",
        "name": "倆倆親子民宿",
        "link": "https://jcobd.pixnet.net/blog/post/90191965"
    },
    {
        "id": 8,
        "image": require("../images/store/store_18.png"),
        "area": "安平區",
        "name": "森行旅",
        "link": "https://jjjiang.pixnet.net/blog/post/406354985"
    },
    {
        "id": 9,
        "image": require("../images/store/store_19.jpeg"),
        "area": "安平區",
        "name": "餘光",
        "link": "https://chunsky1234.pixnet.net/blog/post/364307944"
    },
    {
        "id": 10,
        "image": require("../images/store/store_20.jpeg"),
        "area": "東區",
        "name": "唯識禪居",
        "link": "https://gononone.pixnet.net/blog/post/50331548"
    }
];
